import React, { useState } from "react";
import { all_routes } from "../../router/all_routes";
import { Link } from "react-router-dom";
import PredefinedDateRanges from "../../../core/common/datePicker";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { DatePicker } from "antd";
import CommonSelect from "../../../core/common/commonSelect";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import moment from "moment";
import Loader from "../../../core/common/selfLoder";

interface jobData {
  ID: number;
  job_title: string;
  department: string;
  job_location: string;
  experience: string;
  job_type: string;
  status: any;
  icon: any;
  ctc: any
}

interface jobResponse {
  success: boolean;
  message: string;
  statusCode: string;
  data: jobData[];
}

const Jobs = () => {
  const [jobstatus, setJobstatus] = useState("1");
  const [dateRange, setDateRange] = useState<{
    start: moment.Moment | null;
    end: moment.Moment | null;
  }>({
    start: null,
    end: null,
  });

  const handleRolesDateChange = (start: moment.Moment, end: moment.Moment) => {
    setDateRange({ start, end });
  };

  const payload = {
    status: jobstatus,
    start_date: dateRange.start ? dateRange.start.format("YYYY-MM-DD") : "",
    end_date: dateRange.end ? dateRange.end.format("YYYY-MM-DD") : "",
  };

  const { data: jobResponse, loading: typeLoading } = useApi<jobResponse>(
    "/api/ijp",
    {
      method: "POST",
      autoCall: true,
      payload,
      dependencies: [jobstatus, dateRange],
    }
  );
  return (
    <>
      <Loader loading={typeLoading} />
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">All Jobs </h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={all_routes.employeeDashboard}>
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Career & Support</li>
                  <li className="breadcrumb-item">Open Positions (Jobs)</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    All Jobs
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 ">
                <h5>Current Openings </h5>
                <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                  <div className="me-3">
                    <div className="input-icon-end position-relative">
                      <PredefinedDateRanges onChange={handleRolesDateChange} />
                      <span className="input-icon-addon">
                        <i className="ti ti-chevron-down" />
                      </span>
                    </div>
                  </div>

                  <div className="dropdown me-3">
                    <Link
                      to="#"
                      className="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                      data-bs-toggle="dropdown"
                    >
                      {jobstatus === ""
                        ? "Status"
                        : jobstatus === "1"
                          ? "Open"
                          : jobstatus === "0"
                            ? "Closed"
                            : "Status"}
                    </Link>
                    <ul className="dropdown-menu  dropdown-menu-end p-3">
                      <li onClick={() => setJobstatus("")}>
                        <Link to="#" className="dropdown-item rounded-1">
                          All
                        </Link>
                      </li>
                      <li onClick={() => setJobstatus("1")}>
                        <Link to="#" className="dropdown-item rounded-1">
                          Open
                        </Link>
                      </li>
                      <li onClick={() => setJobstatus("0")}>
                        <Link to="#" className="dropdown-item rounded-1">
                          Closed
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {jobResponse?.data.map((item, index) => (
              <div className="col-xl-3 col-lg-4 col-sm-6">
                <div className="card">
                  <div className="card-body">
                    <div className="card bg-light">
                      <div className="card-body p-3">
                        <div className="d-flex align-items-center">
                          <Link to="#" className="me-2">
                            <span className="avatar avatar-lg bg-gray">
                              <ImageWithBasePath
                                src={item.icon && !item.icon.endsWith("/null") ? item.icon : "assets/img/jobimage.jpeg"}
                                className="w-auto h-auto"
                                alt="icon"
                              />
                            </span>
                          </Link>

                          <div>
                            <h6 className="fw-medium mb-1 text-truncate">
                              <Link to="#">{item.job_title}</Link>
                            </h6>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex flex-column mb-3">
                      <p className="text-dark d-inline-flex align-items-center mb-2">
                        <i className="ti-briefcase text-gray-5 me-2" />
                        {item.department}
                      </p>
                      <p className="text-dark d-inline-flex align-items-center mb-2">
                        <i className="ti ti-map-pin-check text-gray-5 me-2" />
                        {item.job_location}
                      </p>
                      <p className="text-dark d-inline-flex align-items-center">
                        <i className="ti-briefcase text-gray-5 me-2" />
                        {item.experience} years of experience
                      </p>
                      <p className="text-dark d-inline-flex align-items-center" style={{ marginTop: "-12px" }}>
                        <i className=" text-gray-5 me-2" style={{ fontSize: "20px" }}>₹</i>
                        {item.ctc ? `${item.ctc}` : "CTC not available"}
                      </p>
                    </div>
                    <div className="mb-3 d-flex align-items-center gap-3">
                      <span
                        style={{
                          color: "#2e3294",
                          fontWeight: "500",
                          fontSize: "12px"
                        }}
                      >
                        {item.job_type}
                      </span>
                      <span
                        style={{
                          color: "#6C757D",
                          fontWeight: "500",
                          fontSize: "12px"
                        }}
                      >
                        {item.status === "1" ? "Open" : "Close"}
                      </span>
                    </div>


                    <div className="mt-2">
                      {/* Link-styled badges */}
                      <Link
                        to="/job-description"
                        state={{ jobId: item.ID }}
                        style={{ textDecoration: "none" }}
                        className="badge custom_button me-2"
                      >
                        Job Description
                      </Link>

                      <Link
                        to="/job-refrence"
                        state={item}
                        style={{ textDecoration: "none", border: "1px solid #2e3294" }}
                        className="badge bg-secondary-transparent mt-1"
                      >
                        Refer a Friend
                      </Link>
                    </div>

                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Jobs;
